import { Navbar } from "@/components/Navbar";
import { Link } from "react-router-dom";

export function Layout({ children }) {
  return (
    <div className="min-h-screen grain relative">
      <Navbar />
      <main className="relative z-10">{children}</main>
      <footer className="relative z-10 border-t border-white/10 mt-20 py-10 px-5 sm:px-8">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="font-display text-2xl">HHK<span className="text-primary">D</span></div>
          
          </div>
        
      </footer>
    </div>
  );
}
